import { Draggable } from "react-beautiful-dnd";
import { Scope, useFormApi, useFieldApi, Checkbox, useFieldState } from "informedv4";
import { FixedCommentSetFormModel } from "../Types";
import { useState, useEffect } from "react";
import { Required, RequiredNotBlank } from "../../../forms/validation/Required";
import * as React from "react";
import { TextBox } from "../../../forms/informedv4/TextBoxV4";
import { FixedCommentSetTypeEnum } from "../../../misc/api/FixedComments/FixedCommentSetTypes";
import { nameof } from "ts-simple-nameof";
import { FixedComment } from "webportalclient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";

interface FixedCommentEntryProps {
    field: string;
    remove: () => void;
    initialValue: FixedComment;
    index: number;
    editMode: boolean;
}

const FixedCommentEntryFields = ({ field, remove, initialValue, index, editMode }: FixedCommentEntryProps): JSX.Element => {

    const formApi = useFormApi();

    const [followOnAvailable, setFollowOnAvailable] = useState<boolean>(initialValue?.followOnCommentAvailable);
    const fieldApi = useFieldApi(`${field}.${nameof<FixedComment>(fc => fc.displayOrder)}`);

    const setTypeSelected = useFieldState(nameof<FixedCommentSetFormModel>(fc => fc.SetType));

    useEffect(() => {
        var value = fieldApi.getValue();

        fieldApi.setValue(index);

    }, [index]);

    const handleUpdate = () => {
        const followOnCommentAvailable = formApi.getValue(field + '.followOnCommentAvailable');

        setFollowOnAvailable(followOnCommentAvailable as boolean);
    };

    const ValidateFollowOnAnnotation = (value: string) => {
        const followOnCommentAvailable = formApi.getValue(field + '.followOnCommentAvailable');
        const followOnCommentRequired = formApi.getValue(field + '.followOnCommentRequired');

        if (followOnCommentAvailable == true && followOnCommentRequired == true) {
            const trimmedValue = value?.trim();
            return Required(trimmedValue === '' ? undefined : trimmedValue);
        }
    };

    return (
        <Draggable draggableId={`drag-${field}`} index={index} >
            {provided => (<Scope scope={field}>
                <div className="panel-body bottom" ref={provided.innerRef}
                    {...provided.draggableProps}>
                    <div {...provided.dragHandleProps} style={{ display: 'inline-block', cursor: "grab" }} >
                        <FontAwesomeIcon icon={faGripVertical} />&nbsp;
                    </div>
                        <div className="col-md-12">
                            <div className="form-group col-md-6">
                                <label htmlFor={`display-text-${field}`}>Display Text</label>
                                <TextBox name={nameof<FixedComment>(fc => fc.comment)} initialValue={initialValue.comment} id={`display-text-${field}`} field={nameof<FixedComment>(fc => fc.comment)} validate={RequiredNotBlank} />
                            </div>
                            <div className="form-group col-md-5">
                                <label htmlFor={`description-text-${field}`}>Description</label>
                                <TextBox name={nameof<FixedComment>(fc => fc.description)} initialValue={initialValue.description} id={`description-text-${field}`} field={nameof<FixedComment>(fc => fc.description)} validate={RequiredNotBlank} />
                            </div>
                            <div className="col-md-1 pull-right" >
                                <button type="button" className="close" aria-label="Remove" onClick={() => remove()}><span aria-hidden="true">&times;</span></button>
                            </div>
                        </div>
                        <div className="col-md-12" >
                            <div className="form-group col-md-6" hidden={setTypeSelected.value !== FixedCommentSetTypeEnum.Technician}>
                                <label htmlFor={`comment-available-${field}`} className="right">Follow On Comment Available</label>
                                <Checkbox name={nameof<FixedComment>(fc => fc.followOnCommentAvailable)} initialValue={initialValue.followOnCommentAvailable} onChange={() => handleUpdate()} id={`comment-available-${field}`} field={nameof<FixedComment>(fc => fc.followOnCommentAvailable)} />
                            </div>
                            <div className="form-group col-md-6" hidden={!followOnAvailable || setTypeSelected.value !== FixedCommentSetTypeEnum.Technician}>
                                <label htmlFor={`comment-required-${field}`} className="right">Follow On Comment Required</label>
                                <Checkbox name={nameof<FixedComment>(fc => fc.followOnCommentRequired)} initialValue={initialValue.followOnCommentRequired} id={`comment-required-${field}`} field={nameof<FixedComment>(fc => fc.followOnCommentRequired)} />
                            </div>
                            <div className="form-group col-md-12" hidden={!followOnAvailable || setTypeSelected.value !== FixedCommentSetTypeEnum.Technician}>
                                <label htmlFor={`comment-annotation-${field}`}>Follow On Comment Annotation</label>
                                <TextBox name={nameof<FixedComment>(fc => fc.followOnCommentAnnotation)} initialValue={initialValue.followOnCommentAnnotation} id={`comment-annotation-${field}`} field={nameof<FixedComment>(fc => fc.followOnCommentAnnotation)} validate={ValidateFollowOnAnnotation} />
                            </div>
                            <div className="form-group col-md-12" hidden={!editMode}>
                                <label htmlFor={`comment-hidden-${field}`} className="right">Hidden</label>
                                <Checkbox name={nameof<FixedComment>(fc => fc.disabled)} initialValue={initialValue.disabled} id={`comment-hidden-${field}`} field={nameof<FixedComment>(fc => fc.disabled)} />
                            </div>
                        </div>
                        <div hidden={true}>
                            <label htmlFor={`comment-order-${field}`}>Order</label>
                            <TextBox name={nameof<FixedComment>(fc => fc.displayOrder)} initialValue={initialValue.displayOrder.toString()} id={`comment-order-${field}`} field={nameof<FixedComment>(fc => fc.displayOrder)} validate={(value) => Number.parseInt(value) != 0 ? Required(value) : undefined} />
                        </div>
                </div>
            </Scope>)}
        </Draggable>

    )
};

export default FixedCommentEntryFields;

